import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import classNames from 'classnames';

import { Colours, Sizes, ZIndex, BouncingDecimal, GrowingDecimalTakeover } from '@ratehub/base-ui';


function InsuranceSpinner({
    iconComponent,
    title,
    showTitleDot = true,
    description,
    centreContent = false,
    isSpinning = false,
    isFullScreen = false,
    onAnimationEnd,
    ...otherProps
}) {
    const Icon = iconComponent;
    const isAnimated = !Icon;

    const [ startGrowingDecimal, setStartGrowingDecimal ] = useState(false);

    useEffect(() => {
        if (isAnimated && !isSpinning) {
            setStartGrowingDecimal(true);
        }
    }, [ isSpinning ]);

    const handleAnimationEnd = () => {
        setStartGrowingDecimal(false);
        onAnimationEnd && onAnimationEnd();
    };
    return (
        <Choose>
            <When condition={startGrowingDecimal}>
                <GrowingDecimalTakeover
                    top={Sizes.SPACING.EIGHT}
                    left="50%"
                    onAnimationEnd={handleAnimationEnd}
                />
            </When>
            <Otherwise>
                <InsuranceSpinner.Container
                    centreContent={centreContent}
                    className={classNames({ 'is-full-screen': isFullScreen })}
                    {...otherProps}
                >
                    <InsuranceSpinner.CentredContent centreContent={centreContent}>
                        <Choose>
                            <When condition={isAnimated}>
                                <BouncingDecimal />
                            </When>
                            <Otherwise>
                                <InsuranceSpinner.IconContainer>
                                    <Icon
                                        width="100%"
                                        height="100%"
                                        stroke={Colours.BLUEBERRY}
                                    />
                                </InsuranceSpinner.IconContainer>
                            </Otherwise>
                        </Choose>
                        <h2 className={classNames({ showDot: showTitleDot }, 'rh-title-2xl', 'rh-my-1_5')}>
                            {title}
                        </h2>
                        <If condition={description}>
                            <h3 className={classNames('rh-title-m', 'weight-regular')}>
                                {description}
                            </h3>
                        </If>
                    </InsuranceSpinner.CentredContent>
                </InsuranceSpinner.Container>
            </Otherwise>
        </Choose>
    );
}

InsuranceSpinner.propTypes = {
    iconComponent: PropTypes.elementType,
    description: PropTypes.node,
    title: PropTypes.node.isRequired,
    showTitleDot: PropTypes.bool,
    centreContent: PropTypes.bool,
    isSpinning: PropTypes.bool,
    isFullScreen: PropTypes.bool,
    onAnimationEnd: PropTypes.func,
};

InsuranceSpinner.Container = styled.div`
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;

    z-index: ${ZIndex.FULL_SCREEN};

    background-color: ${Colours.COCONUT_DARK};

    &.is-full-screen {
        position: fixed;
    }

    ${props => props.centreContent && `
        display: flex;
        flex-direction: column;
        justify-content: space-around;
    `}
`;

InsuranceSpinner.CentredContent = styled.div`
    max-width: 600px;

    ${props => !props.centreContent && `
        transform: translateY(${Sizes.SPACING.EIGHT});
    `}

    padding: ${Sizes.SPACING.TWO_AND_A_HALF};
    margin: 0 auto;
    text-align: center;
`;

InsuranceSpinner.IconContainer = styled.div`
    max-width: ${Sizes.ICONS['3XL']};
    max-height: ${Sizes.ICONS['3XL']};

    margin: 0 auto;
`;

export default InsuranceSpinner;
